import { useState } from 'react';

import { Badge, Group, Title } from '@mantine/core';

import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button } from '../../../../../../shared/components/UI/Button/Button';

import { CreateBuyerSimulationBidResponseModal } from './CreateBuyerSimBidResponseModal';

export const Header = () => {
  const { t } = useTranslation('buyerSimulation');
  const [createBidResponseModalOpenned, setCreateBidResponseModalOpenned] =
    useState(false);
  return (
    <Group noWrap position="apart">
      <CreateBuyerSimulationBidResponseModal
        opened={createBidResponseModalOpenned}
        closeModal={() => setCreateBidResponseModalOpenned(false)}
      />
      <Group noWrap spacing="02">
        <Title order={3}>{t('title')}</Title>
        <Badge color="blue">BETA</Badge>
      </Group>
      <Button
        leftIcon={<IconPlus />}
        onClick={() => setCreateBidResponseModalOpenned(true)}
      >
        {t('CTA')}
      </Button>
    </Group>
  );
};
